import { FC } from 'react';

interface RtpSessionLog {
  _id: string;
  painNRS: number;
  notes?: string;
  createdAt: string;
}

interface RtpNotesHistoryProps {
  sessionLogs: RtpSessionLog[];
}

export const RtpNotesHistory: FC<RtpNotesHistoryProps> = ({ sessionLogs }) => {
  const logsWithNotes = sessionLogs
    .filter((log) => log.notes && log.notes.trim())
    .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());

  if (logsWithNotes.length === 0) {
    return <div style={{ padding: 16, textAlign: 'center', color: '#718096', fontSize: 13 }}>Nessuna nota registrata.</div>;
  }

  const getNrsBadgeColor = (nrs: number) => {
    if (nrs >= 7) return { bg: '#FED7D7', color: '#C53030' };
    if (nrs >= 4) return { bg: '#FEFCBF', color: '#975A16' };
    return { bg: '#C6F6D5', color: '#276749' };
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8, maxHeight: 300, overflowY: 'auto' }}>
      {logsWithNotes.map((log) => {
        const badge = getNrsBadgeColor(log.painNRS);
        return (
          <div
            key={log._id}
            style={{
              padding: '10px 14px',
              border: '1px solid #e2e8f0',
              borderRadius: 8,
              backgroundColor: 'var(--c-card-bg)',
            }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
              <span style={{ fontSize: 12, color: '#718096' }}>
                {new Date(log.createdAt).toLocaleDateString('it-IT', { day: '2-digit', month: 'short', year: 'numeric' })}
              </span>
              <span
                style={{
                  padding: '2px 8px',
                  borderRadius: 10,
                  fontSize: 11,
                  fontWeight: 600,
                  backgroundColor: badge.bg,
                  color: badge.color,
                }}
              >
                NRS {log.painNRS}
              </span>
            </div>
            <div style={{ fontSize: 13, color: '#2D3748', lineHeight: 1.5 }}>{log.notes}</div>
          </div>
        );
      })}
    </div>
  );
};

export default RtpNotesHistory;
